module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fengxiang"
  }, [_c('qrcode', {
    attrs: {
      "value": "http://front.wh.jinxin-fertility.com/#/SystemSurvey?personname=200",
      "type": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://front.wh.jinxin-fertility.com/daohang.jpg"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-066c6cd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/ceshi/fenxiang.vue
// module id = f+JR
// module chunks = 6